var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 20C3.75 11.0284 11.0284 3.75 20 3.75C28.9716 3.75 36.25 11.0284 36.25 20C36.25 28.9716 28.9716 36.25 20 36.25C11.0284 36.25 3.75 28.9716 3.75 20ZM20 6.25C12.4091 6.25 6.25 12.4091 6.25 20C6.25 27.5909 12.4091 33.75 20 33.75C27.5909 33.75 33.75 27.5909 33.75 20C33.75 12.4091 27.5909 6.25 20 6.25Z",
    fill: "#25A249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.304 12.7929C28.8326 13.2369 28.9012 14.0254 28.4571 14.554L17.9571 27.054C17.7244 27.3311 17.3831 27.4937 17.0214 27.4998C16.6596 27.506 16.3129 27.3552 16.0709 27.0862L11.5709 22.0862C11.1091 21.5731 11.1507 20.7827 11.6638 20.3209C12.1769 19.8591 12.9673 19.9007 13.4291 20.4138L16.9675 24.3453L26.5429 12.946C26.9869 12.4174 27.7754 12.3489 28.304 12.7929Z",
    fill: "#25A249"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.7e16eb062cc8589931d60ae9f95c05bc.svg";
export { ForwardRef as ReactComponent };